import { StyleSheet, View, Animated } from "react-native";
import React, { useEffect, useRef } from "react";
import CustomerLoader from "@assets/svg/CustomerLoader";
import StatsLoader from "@assets/svg/StatsLoader";
import ShopLoader from "@assets/svg/ShopLoader";
const Loader = () => {
  const fadeAnim1 = useRef(new Animated.Value(1)).current;
  const fadeAnim2 = useRef(new Animated.Value(0)).current;
  const fadeAnim3 = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    handlePress();
  }, []);

  const handlePress = () => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(fadeAnim2, {
          toValue: 1,
          duration: 2000,
          delay: 500,
          useNativeDriver: true,
        }),
        Animated.timing(fadeAnim2, {
          toValue: 0,
          duration: 2000,
          delay: 500,
          useNativeDriver: true,
        }),
        Animated.timing(fadeAnim3, {
          toValue: 1,
          duration: 2000,
          useNativeDriver: true,
          delay: 500,
        }),
        Animated.timing(fadeAnim3, {
          toValue: 0,
          duration: 2000,
          useNativeDriver: true,
          delay: 500,
        }),
        Animated.timing(fadeAnim1, {
          toValue: 1,
          duration: 2000,
          useNativeDriver: true,
          delay: 500,
        }),
      ]),
      { interation: Number.MAX_SAFE_INTEGER },
    ).start();
  };

  return (
    <>
      <View style={styles.container}>
        <Animated.View style={[styles.pos, { opacity: fadeAnim1 }]}>
          <CustomerLoader />
        </Animated.View>
        <Animated.View style={[styles.pos, { opacity: fadeAnim2 }]}>
          <StatsLoader />
        </Animated.View>
        <Animated.View style={[styles.pos, { opacity: fadeAnim3 }]}>
          <ShopLoader />
        </Animated.View>
      </View>
    </>
  );
};

export default Loader;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
  },
  pos: {
    position: "absolute",
  },
});
